
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lon/dashboard",
      function () {
        return require("private-next-pages/lon/dashboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lon/dashboard"])
      });
    }
  